import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FormFieldConstants } from ".";

export const AllowanceTypes = [
  WintSuperkollAPIModel.SalaryDeviationType.Bonus,
  WintSuperkollAPIModel.SalaryDeviationType.Mileage,
  WintSuperkollAPIModel.SalaryDeviationType.CommissionFee,
  WintSuperkollAPIModel.SalaryDeviationType.CommissionVacationPaid,
  WintSuperkollAPIModel.SalaryDeviationType.CommissionVacationSaved,
  WintSuperkollAPIModel.SalaryDeviationType.WithdrawalsSavedVacation,
  WintSuperkollAPIModel.SalaryDeviationType.Allowance,
  WintSuperkollAPIModel.SalaryDeviationType.AllowanceForeign,
  WintSuperkollAPIModel.SalaryDeviationType.WorkedHours,
  WintSuperkollAPIModel.SalaryDeviationType.WithdrawalCompensation,
  WintSuperkollAPIModel.SalaryDeviationType.DepositedCompensation,
  WintSuperkollAPIModel.SalaryDeviationType.CustomDeviationCompensation,
];

//TODO double check name used for below type
export const TimeReportingDeviationTypes = [
  WintSuperkollAPIModel.SalaryDeviationType.Overtime30,
  WintSuperkollAPIModel.SalaryDeviationType.Overtime50,
  WintSuperkollAPIModel.SalaryDeviationType.Overtime75,
  WintSuperkollAPIModel.SalaryDeviationType.Overtime100,
  WintSuperkollAPIModel.SalaryDeviationType.Overtime150,
  WintSuperkollAPIModel.SalaryDeviationType.Overtime200,
  WintSuperkollAPIModel.SalaryDeviationType.OvertimeSimple,
  WintSuperkollAPIModel.SalaryDeviationType.OvertimeQualified,
  WintSuperkollAPIModel.SalaryDeviationType.ExtraTime,
  WintSuperkollAPIModel.SalaryDeviationType.UnsocialWorkingHours1,
  WintSuperkollAPIModel.SalaryDeviationType.UnsocialWorkingHours2,
  WintSuperkollAPIModel.SalaryDeviationType.UnsocialWorkingHours3,
  WintSuperkollAPIModel.SalaryDeviationType.UnsocialWorkingHours4,
  WintSuperkollAPIModel.SalaryDeviationType.OnCall,
  WintSuperkollAPIModel.SalaryDeviationType.Preparedness,
  WintSuperkollAPIModel.SalaryDeviationType.TravelTimeSimple,
  WintSuperkollAPIModel.SalaryDeviationType.TravelTimeQualified,
  WintSuperkollAPIModel.SalaryDeviationType.ReducedWorkingHours,
];

export const LeaveTypes = [
  WintSuperkollAPIModel.SalaryDeviationType.Vacation,
  WintSuperkollAPIModel.SalaryDeviationType.Sick,
  WintSuperkollAPIModel.SalaryDeviationType.CareOfChildren,
  WintSuperkollAPIModel.SalaryDeviationType.ParentalLeave,
  WintSuperkollAPIModel.SalaryDeviationType.TenDays,
  WintSuperkollAPIModel.SalaryDeviationType.Absence,
  WintSuperkollAPIModel.SalaryDeviationType.PaidShortTermLeave,
  WintSuperkollAPIModel.SalaryDeviationType.CustomTimeDeviation,
];

export const CommissionTypes = [
  WintSuperkollAPIModel.SalaryDeviationType.CommissionVacationPaid,
  WintSuperkollAPIModel.SalaryDeviationType.CommissionVacationSaved,
];

export const CustomTimeDeviations = [WintSuperkollAPIModel.SalaryDeviationType.CustomTimeDeviation];

export const OtherDeviationTypes = [...TimeReportingDeviationTypes, ...CustomTimeDeviations];

export const SalaryDeviationYearMonthKey = FormFieldConstants.SalaryDeviation.Filter.YearAndMonth;
export const SalaryDeviationFilterKey = "filter";
export const DefaultPayoutDay = 25;

export const WintDeviationGroupByPersonChartKey = "GroupByPerson";
export const WintDeviationGroupByDeviationTypeChartKey = "GroupByDeviationType";
